import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import {
  CabinEventClient,
  EventFormStatus,
  CabinEventReport,
  CabinEventReportDTO,
  ProblemDetails,
} from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useUpdateCabinEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<CabinEventReportDTO, ProblemDetails, CabinEventReport>({
    mutationKey: [queryKeys.CabinEvent.Update],
    mutationFn: (report: CabinEventReport) => {
      if (report.status === EventFormStatus.Approved) {
        return cabinEventClient.approve(report.id);
      }
      return cabinEventClient.update(report);
    },
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useUpdateCabinEvent;
